import { NewFilterOption } from '@/components/FilterNew/types';

import { UserFilterItemType } from '../hooks/useUsersFilter';

export const getUserFilterOption = (user: UserFilterItemType): NewFilterOption => ({
  value: user.id!,
  label: user.name || '',
  src: user.profilePicture ?? '',
  // whole user shouldn't be spread here, fix it @iamsaumya
  ...user,
});
